export const NEW_COMPETITOR_CONTAINER = {
  FILTERS: {
    scores: '',
    results: 'results',
    standings: 'standings',
    fixtures: 'fixtures',
    brackets: 'brackets',
    stats: 'stats',
    squad: 'squad',
    transfers: 'transfers',
    matches: 'matches',
    news: 'news',
    highlights: 'highlights'
  },

  ACTION_TYPES: {
    breadcrumbsHandler: 'breadcrumbsHandler',
    fetchMetadata: 'fetchMetadata'
  }
};